import React, { Component } from "react";  
   
class Comp6 extends Component {  
  constructor() {  
    super();  
    this.state = {  
      name: "ReactJS",
      feesinfo: '',
      logged_auth: localStorage.getItem("logged_auth") ? localStorage.getItem("logged_auth") : false,
    };  
    this.toggleModalopen.bind(this);
  }  

   componentDidMount() {

      let annulafee = this.props.annualfee;
      let recurringfee = this.props.recurringfee;
      let processingfee = this.props.processingfee;
      this.setState({annulafee:annulafee,processingfee:processingfee, recurringfee:recurringfee});
       
   }


 toggleModalopen = (e) => {
    this.props.toggleModalopen();
  }
   
  render() {  
    return <div id="fees_section"><h3>Fees & Structure</h3>
           { this.state.logged_auth && (
           <div class="fees_block">
              <div className='col-md-12 n6-desc'>
                <div class="row">
                  <div class="col-6">
                    <div class="ki_title">Indicative Annual Fee</div>
                    <div class="ki_ans">{'₹ '}{this.state.annulafee}</div>
                  </div>
                  <div class="col-6">
                    <div class="ki_title">Recurring Fees</div>
                    <div class="ki_ans">{'₹ '}{this.state.recurringfee}</div>
                  </div>
                  <div class="col-6">
                    <div class="ki_title">Application Fees</div>
                    <div class="ki_ans">{'₹ '}{this.state.processingfee}</div>
                  </div>
                  
                </div>
              </div>
          </div>
           ) }
           { !this.state.logged_auth && (
                <div class="fees_block">
                    <div className='col-md-12 n6-desc smallwarning'>
                    Please <span class='linkinwarning' onClick={this.toggleModalopen}>Sign In</span> or <span class='linkinwarning' onClick={this.toggleModalopen}>Sign Up</span> to see this information
                    </div>
                </div>
           )}
          </div>
  }  
}  
   
export default Comp6;